<template>
  <section class="header-title">
    <template v-if="version == 1"> ANÁLISIS <span class="header-title__bold">TIEMPO EFECTIVO</span> </template>
    <template v-if="version == 2"
      ><div class="title-aux">
        ANÁLISIS <span class="header-title__bold">TIEMPO EFECTIVO</span> EN LO QUE VA DEL TORNEO
      </div></template
    >
    <template v-if="version == 3"
      ><div class="title-aux-2">
        ANÁLISIS <span class="header-title__bold">TIEMPO EFECTIVO</span> EN LO QUE VA DEL TORNEO
      </div></template
    >
  </section>
</template>

<script>
export default {
  name: 'HeaderTitle',
  components: {},
  props: {
    version: {
      type: Number,
      default: 1,
    },
  },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style lang="scss" scoped>
.title-aux-2 {
  @media screen and (max-width: 700px) {
    font-size: 18px;
  }
  @media screen and (max-width: 600px) {
    font-size: 17px;
  }
  @media screen and (max-width: 500px) {
    font-size: 16px;
  }
  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
  @media screen and (max-width: 420px) {
    font-size: 13px;
  }
  @media screen and (max-width: 400px) {
    font-size: 12px;
  }
  @media screen and (max-width: 380px) {
    font-size: 11px;
  }
  @media screen and (max-width: 360px) {
    font-size: 10px;
  }
  @media screen and (max-width: 330px) {
    font-size: 9px;
  }
}
.title-aux {
  @media screen and (max-width: 740px) {
    font-size: 18px;
  }
  @media screen and (max-width: 600px) {
    font-size: 16px;
  }
  @media screen and (max-width: 500px) {
    font-size: 14px;
  }
  @media screen and (max-width: 450px) {
    font-size: 12px;
  }
  @media screen and (max-width: 380px) {
    font-size: 10px;
  }
  @media screen and (max-width: 330px) {
    font-size: 9px;
  }
}
.header-title {
  width: 100%;
  height: 20px;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 20px;
  letter-spacing: normal;
  text-align: center;
  color: #132839;
  font-family: 'Avenir-Regular';
  &__bold {
    font-family: 'Avenir-Bold';
  }
  @media screen and (max-width: 1030px) {
    font-size: 19px;
  }
  @media screen and (max-width: 380px) {
    font-size: 17px;
  }
  @media screen and (max-width: 380px) {
    font-size: 15px;
  }
}
</style>
